import { Suspense } from "react";
import { AllFindAJobRoutes } from ".";
import Loader from "../../components/loader";
import { Routes, Route } from "react-router-dom";

const FindAJobRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {AllFindAJobRoutes?.map((item, index) => {
          return (
            <Route key={index} exact path={item.path} element={item?.element} />
          );
        })}

        {/* <Route exact path="*" element={<PageNotFound />} /> */}
      </Routes>
    </Suspense>
  );
};

export default FindAJobRoutes;
